import React from "react";

const MAP = {
  // Permit statuses
  "Approved": "status-success",
  "Inspection Passed": "status-success",
  "Signed Off": "status-success",
  "Pending Review": "status-warning",
  "Inspection Scheduled": "status-info",
  "Denied": "status-danger",
  "Expired": "status-danger",
  "Failed": "status-danger",
  "Missed": "status-danger",
  "Scheduled": "status-info",
  "Passed": "status-success",
  "active": "status-success",
  // Filing statuses
  "Pre-Filed": "status-neutral",
  "Filed": "status-info",
  "Payment Required": "status-warning",
  "Plan Review": "status-info",
  "Plan Approved": "status-success",
  "Plan Disapproved": "status-danger",
  "Permit Issued": "status-success",
  "Superseded": "status-neutral",
  "Withdrawn": "status-neutral",
  // Violation statuses
  "Open": "status-danger",
  "Resolved": "status-success",
  "Stop Work Order": "status-danger",
};

export const StatusBadge = ({ status, testId }) => {
  const cls = MAP[status] || "status-neutral";
  return (
    <span className={`status-pill ${cls}`} data-testid={testId}>
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
};

export const JobStatusDot = ({ color }) => {
  const palette = { green: "#22C55E", yellow: "#EAB308", red: "#EF4444" };
  return (
    <span
      className="inline-block w-2.5 h-2.5 rounded-full"
      style={{ background: palette[color] || "#A1A1AA" }}
    />
  );
};
